import * as React from 'react';

import {styled} from '@mui/material/styles';

import Stack from '@mui/material/Stack';
import Step from '@mui/material/Step';
import Stepper from '@mui/material/Stepper';

const STEPS = 9;

const StepMarker = styled('div')(
    ({theme}) => ({
        height: '8px',
        width: `100%`,
        borderRadius: '4px',
    }),
);


const ProgressStepper = (props: { step: number, setStep: any }) => {

    const {step, setStep} = props;

    const handleSetStep = (newStep: number) => {
        // There is no way back after submitting the form
        if (step === STEPS) {
            return;
        }

        if (newStep > 0 && newStep <= STEPS && newStep < step) {
            setStep(newStep);
        }
    };

    /**
     * RENDER COMPONENT
     */
    return (
        <Stack spacing={4} sx={{width: '100%', mb: 5}}>
            <Stepper activeStep={5} connector={null}>
                {Array.from({length: STEPS}).map((v, i) => (
                    <Step
                        key={`step-${i}`}
                        sx={{
                            width: `${100 / STEPS}%`,
                            px: '1%',
                        }}
                    >
                        <StepMarker
                            sx={{
                                backgroundColor: step > i ? '#C8181E' : '#E5E5E5',
                                cursor: (step !== STEPS && step > i + 1) ? 'pointer' : 'default',
                            }}
                            onClick={() => handleSetStep(i + 1)}
                        />
                    </Step>
                ))}
            </Stepper>
        </Stack>
    );
};

export default ProgressStepper;
